export default __webpack_public_path__ + "static/media/LogoForm.b415a9aa.svg";